// extracted by mini-css-extract-plugin
export default {"container":"fD-z","dimension":"gD-z","dimensionLabels":"hD-z"};